import React from "react";
import PropTypes from "prop-types";

const Item = (props) => {
  const { config } = props;
  return (
    <li className={config.class}>
      {config.text}
      {config.id || config.default ? (
        <span id={config.id}>{config.default}</span>
      ) : (
        ""
      )}
    </li>
  );
};

Item.propTypes = {
  config: PropTypes.object.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Item.js